import ViewPage from './ViewPage';

export default ViewPage;